import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell"
import {currencySymbol} from "../../../../../../gd/format/currency-symbol"
import {ItemModelV2_CalculatedValues} from "../../../../../../model2/item2/calculated/@type";

// const debug = "FieldItemModelCalculatedServiceCost_TableCell"
const debug = false

export default function FieldItemModelCalculatedServiceCost_TableCell (props: FieldTableCellProps) {


    const classes = Classes("cell-flex ui5-txt-less-important-small")

    let content = null
    let showSummary = false

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]

    if (props.listItem.view.isCollapsed &&
        !!calculatedValues?.total?.value &&
        calculatedValues.total.value > calculatedValues.own) {
        content         = calculatedValues.total.value
        showSummary     = true
    } else if (calculatedValues?.own) {
        content         = calculatedValues.own
    }

    const hasValue : boolean = !!content && content > 0
    const displayValue = props.field.getDisplayValue(content)

    return (
        <React.Fragment>
            <div className={classes} style={getTableCellStyle(props)}>
                {showSummary && <div className="ui5-ico-12 i5-summary-symbol m-r-5 m-t-1"/>}

                {hasValue &&
                    <>
                        <span className="ui5-txt-not-important-small m-r-3">{currencySymbol()}</span>
                        {displayValue}
                    </>
                }
            </div>
        </React.Fragment>
    )

}



